<template>
  <div class="manage-batch">

    <!-- START Search Box -->
    <div class="row">
      <div class="col">
        <div class="card shadow">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-3">
                <b-form-group label-class="col-form-label"
                              label="Search" label-for="noticeSearchBox"
                              label-cols="3" content-cols="9">
                  <b-input-group>
                    <b-form-input id="batchSearchBox" type="search" placeholder="Batch ID or 배치명" v-model="searchWord" />
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Search Box -->

    <!-- START Batch List -->
    <div class="row">
      <div class="col">
        <div class="card shadow">
          <div class="card-body">
            <div style="max-height: 66vh;">

              <div class="row mb-2">
                <div class="col">
                  <div class="float-end me-2">
                    <total-count :count="items.length" unit="건" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="common-sticky-table">
                  <b-table class="datatables text-nowrap"
                           hover bordered show-empty
                           responsive sticky-header="53vh" no-border-collapse
                           selectable select-mode="single" selected-variant="secondary"
                           :fields="fields" :items="items"
                           :filter="searchWord"
                           :filter-included-fields="filterFields"
                           :filter-debounce="150"
                           @row-selected="selectRow"
                           @row-dblclicked="openUpdateModal">

                    <template #cell(batchId)="data">
                      <div class="text-start">{{ data.item.batchId }}</div>
                    </template>
                    <template #cell(batchName)="data">
                      <div class="text-start">{{ data.item.batchName }}</div>
                    </template>
                    <template #cell(batchDesc)="data">
                      <div class="text-start">{{ data.item.batchDesc }}</div>
                    </template>

                  </b-table>
                </div>
              </div>

              <div class="row">
                <div class="mt-3">
                  <b-pagination class="mb-1 pagination-no-border"size="sm" align="center" v-model="paginationOptions.currentPage"
                                first-number last-number prev-text="<" next-text=">"
                                :total-rows="paginationOptions.totalCount"
                                :per-page="paginationOptions.perPage"/>
                </div>
              </div>

              <div class="row">
                <div class="manage-btns-container">
                  <b-button variant="outline-deep-green" class="me-3" :disabled="!selectedRow" @click="openUpdateModal(selectedRow)">수정</b-button>
                  <b-button variant="outline-deep-green" @click="showCreateModal = true">등록</b-button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Batch List -->


    <b-modal v-model="showUpdateModal"
             centered scrollable no-close-on-backdrop
             header-class="bg-modal-header"
             ok-title="저장" cancel-title="취소"
             @ok="updateBatch" >

      <template #modal-header>
        <div class="fw-bold">Batch 수정</div>
      </template>

      <div>
        <MDKForm
            ref="_form"
            :fields="formFields"
            :entity="selectedRow? selectedRow : {}">
          <template v-slot:inputs="props">
            <template v-if="props.column.key === 'batchId'">
              <MDKInput :field="props.column" :disabled="true" :value="selectedRow.batchId"
              />
            </template>
          </template>
        </MDKForm>
      </div>
    </b-modal>

    <b-modal v-model="showCreateModal"
             centered scrollable no-close-on-backdrop
             header-class="bg-modal-header"
             ok-title="저장" cancel-title="취소"
             @ok="createBatch">

      <template #modal-header>
        <div class="fw-bold">Batch 등록</div>
      </template>

      <div>
        <MDKForm
            ref="_form"
            :fields="formFields"
            :entity="{}"
        >
        </MDKForm>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TotalCount from "@/views/components/totalCount.vue";

export default {
  name: "manageBatch",
  components: { TotalCount },
  data() {
    const _api = this.$_app.service.batch;
    return {
      jqlApi: _api,
      fields: _api.columnInfos,
      items: [],
      searchWord: null,
      filterFields: [ 'batchId', 'batchName' ],
      paginationOptions: {
        currentPage: 1,
        totalCount : 0,
        perPage: 10,
      },
      showCreateModal: false,
      showUpdateModal: false,
      selectedRow: null,
      formFields: [
        _api.schema.batchId,
        _api.schema.batchName,
        _api.schema.batchDesc,
        _api.schema.batchType,
        _api.schema.executeTime
      ]
    }
  },
  mounted() {
    const vm = this;
    vm.getItems();
  },
  methods: {
    selectRow(row) {
      const vm = this;
      vm.selectedRow = row[0];
    },
    openUpdateModal(row) {
      const vm = this;

      vm.selectedRow = row;
      vm.showUpdateModal = true;
    },
    updateBatch() {
      const vm = this;
      let entity = vm.$refs._form.getUpdatedProperties();
      vm.jqlApi.updateByIdList(vm.selectedRow.id, entity)
          .then(res => {
            vm.$swal("수정완료", '수정이 완료되었습니다.', 'success')
            vm.getItems()
          })
    },
    createBatch() {
      const vm = this;
      let entity = vm.$refs._form.getUpdatedProperties()

      vm.jqlApi.add(entity)
          .then(res => {
            vm.$swal('등록완료', '등록이 완료되었습니다..', 'success')
            vm.getItems();
          })
          .catch(err => {
            console.log(err)
            vm.$swal('등록실패', '등록에 실패하였습니다.', 'error')
            vm.getItems();
          })
    },
    getItems() {
      const vm = this;
      let jql = {};
      let sortOptions = 'batchName';
      vm.jqlApi.searchByJql(jql, sortOptions, 2000, 1)
          .then(res => {
            vm.items = res.content;
            vm.paginationOptions.totalCount = res.totalElements;
          }).catch(err => {
        console.log(err);
      });
    }
  },
}
</script>